export const AUTO_CAMPAIGN_TYPES = {
    REGULAR: 'regular',
    DIVERSITY: 'diversity',
    HYBRID: 'hybrid',
    MANUAL_MESSAGE: 'manualMessage',
};

export const AUTO_CAMPAIGN_DIVERSITY_IDS = {
    WOMEN: 'female',
    AFRICAN: 'black',
    LATIN: 'hispanic',
    ASIAN: 'asian',
    VETERANS: 'veteran',
};

export const AUTO_CAMPAIGN_TYPE_LABELS = {
    [AUTO_CAMPAIGN_TYPES.REGULAR]: 'AUTO_CAMPAIGN_TYPE_LABEL_REGULAR',
    [AUTO_CAMPAIGN_TYPES.DIVERSITY]: 'AUTO_CAMPAIGN_TYPE_LABEL_DIVERSITY',
    [AUTO_CAMPAIGN_TYPES.HYBRID]: 'AUTO_CAMPAIGN_TYPE_LABEL_HYBRID',
    [AUTO_CAMPAIGN_TYPES.MANUAL_MESSAGE]: 'AUTO_CAMPAIGN_TYPE_LABEL_MANUAL_MESSAGE',
};

export const DIVERSITY_TYPE_LABELS = {
    [AUTO_CAMPAIGN_DIVERSITY_IDS.WOMEN]: 'GENDER',
    [AUTO_CAMPAIGN_DIVERSITY_IDS.AFRICAN]: 'BLACK_DIVERSITY_FILTER_VALUE',
    [AUTO_CAMPAIGN_DIVERSITY_IDS.LATIN]: 'HISPANIC_DIVERSITY_FILTER_VALUE',
    [AUTO_CAMPAIGN_DIVERSITY_IDS.ASIAN]: 'ASIAN_DIVERSITY_FILTER_VALUE',
    [AUTO_CAMPAIGN_DIVERSITY_IDS.VETERANS]: 'VETERANS_DIVERSITY_FILTER_VALUE',
};
